<template>
    <div class="col-sm-12 nopads">
        <div class="content-header-container"
             v-bind:style="{ backgroundImage: 'url(' + getBackground() + ')' }">
            <transition name="fade">
                <div v-if="!teamBackgroundImage && !background" class="header-img-overlay">
                </div>
            </transition>
            <fair-image
                    v-if="team"
                    :default-url="getUrl(logo)"
                    :image-id="team.logo ? team.logo.id:null"
                    class="team-logo z-10"
            />
            <span class="header-title z-10">{{ teamUpdate.name }}</span>
        </div>
        <b-form>
            <span class="card-title pl-2 pt-3">
                {{ isEditing() ? $t('team.edit'):$t('team.add') }}
            </span>
            <div class="col-sm-12">
                <!--Name-->
                <b-form-group
                        class="title"
                        label-for="name">
                    <span class="span-title">
                        {{ $t('team.name') }}
                    </span>
                    <b-form-input
                            id="name"
                            v-model="teamUpdate.name"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--Description-->
                <b-form-group
                        class="title"
                        label-for="description">
                  <span class="span-title">
                   {{ $t('team.description') }}
                  </span>
                    <b-form-input
                            id="description"
                            v-model="teamUpdate.description"
                            type="text"
                            size="mb"
                    />
                </b-form-group>
                <!-- active -->
                <b-form-group
                        class="title"
                        label-for="organization">
                  <span class="span-title">
                   {{ $t('team.active') }}
                  </span>
                    <b-form-checkbox
                            id="active"
                            v-model="teamUpdate.active"
                            name="active"
                    >
                        {{ $t('team.active_desc') }}
                    </b-form-checkbox>
                </b-form-group>

                <!--Organization-->
                <b-form-group
                        class="title"
                        label-for="organization">
                  <span class="span-title">
                   {{ $t('team.organization') }}
                  </span>
                    <b-form-input
                            id="organization"
                            v-model="teamUpdate.organization.name"
                            type="text"
                            size="mb"
                            :disabled="true"
                    />
                </b-form-group>

                <fair-image-picker
                        :label="$t('team.logo')"
                        :hint="$t('team.logo_hint')"
                        v-model="logo"/>

                <fair-image-picker
                        :label="$t('team.photo')"
                        v-model="background"/>

                <div class="col-sm-12 button-container p-0 pb-3">
                    <b-button
                            class="fair-button"
                            variant="danger"
                            :disabled="loading"
                            @click.stop="$emit('close')"
                    >
                          <span>
                              {{ $t('common.cancel') }}
                          </span>
                    </b-button>

                    <b-button
                            class="fair-button"
                            variant="success"
                            :disabled="loading"
                            @click.stop="submitTeam"
                    >
                          <span>
                              {{ $t('common.save') }}
                          </span>
                    </b-button>
                </div>
            </div>
        </b-form>

        <members v-if="isEditing()"
                :team="team"
                @alert="showAlert"/>

        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </div>
</template>

<script>
    import FairApi from '../../modules/api'
    import {timeMixin} from "../../mixins/TimeMixin"
    import Members from "../member/Members";
    import FairImage from "../FairImage";
    import FairImagePicker from "../FairImagePicker";

    export default {
        name: 'team-editor',
        components: {FairImage, FairImagePicker, Members},
        mixins: [timeMixin],
        props: {
            team: {
                type: Object,
                default: null
            },
            photoUrl: {
                type: String,
                default: null
            }
        },

        data: function () {
            return {
                loading: false,
                teamUpdate: null,
                users: [],
                logo: null,
                background: null,
                teamBackgroundImage: null
            }
        },

        created() {
            this.teamUpdate = this.newTeam(this.team)
        },

        mounted() {
            if (this.team) {
                this.fetchBackgroundImage()
            }
        },

        methods: {
            getBackground: function () {
                if (!this.background) {
                    return this.teamBackgroundImage
                } else {
                    return this.getUrl(this.background)
                }
            },

            getUrl: function (image) {
                if (image) {
                    URL.revokeObjectURL(image)
                    return URL.createObjectURL(image)
                } else {
                    return ""
                }
            },

            newTeam: function (like) {
                return {
                    id: null,
                    name: '',
                    description: null,
                    organization: this.$store.state.user.organization,
                    created: null,
                    ...like
                }
            },

            submitTeam: function () {
                let json = this.setDefaultValues(this.teamUpdate)
                this.tmp = json
                if (json !== undefined) {
                    this.loading = true
                    let formData = new FormData()
                    if (this.teamUpdate.logo !== null || this.logo !== null) {
                        formData.append('logo', this.logo)
                    }
                    else {
                        this.$emit('alert', this.$t('common.no_logo'))
                        this.loading = false;
                        return;
                    }
                    if (this.teamUpdate.background !== null || this.background !== null) {
                        formData.append('background', this.background)
                    } else {
                        this.$emit('alert', this.$t('common.no_picture'))
                        this.loading = false;
                        return;
                    }
                    if (this.isEditing()) {
                        FairApi.postWithFile(FairApi.teamUpdate(), json, formData, this.success, this.fail)
                    } else {
                        FairApi.postWithFile(FairApi.team(), json, formData, this.success, this.fail)
                    }
                }
            },

            setDefaultValues: function (teamUpdate) {
                let team = JSON.parse(JSON.stringify(teamUpdate))
                if (!team.name) {
                    this.$emit('alert', this.$t('team.invalid_name'))
                    return undefined
                }

                if(!team.logo && !this.logo) {
                    this.$emit('alert', this.$t('team.no_logo'))
                    return undefined
                }

                  if(!team.background && !this.background) {
                    this.$emit('alert', this.$t('team.no_picture'))
                    return undefined
                }

                return team
            },

            photoSuccess: function () {
                this.closeAndUpdate()
            },

            success: function () {
                this.closeAndUpdate()
            },

            closeAndUpdate: function () {
                this.$emit('closeAndUpdate')
                this.loading = false
            },

            fail: function (response) {
                this.loading = false
                if (response.status === 403) {
                    this.$emit('alert', this.$t('team.unauthorized'))
                } else {
                    this.$emit('alert', this.$t('common.alert_update_failed'))
                }
            },

            isEditing: function () {
                return this.team && this.team.id
            },

            showAlert: function (msg) {
                this.$emit('alert', msg)
            },

            fetchBackgroundImage: function () {
                if (this.team.background) {
                    FairApi.get(FairApi.photo(this.team.background.id), this.successImage, this.failImage)
                }
            },

            successImage: function (response) {
                this.teamBackgroundImage = response
                this.loading = false
            },

            failImage() {
                this.loading = false
            }
        }
    }
</script>
